import { BitmapLayer, TileLayer } from "deck.gl";


const GOOGLEMAP_API_KEY = "AIzaSyA8X-e3Naz_Pu50cP8bdDQUZukKrXMqDGs"

export function renderLayers(props) {
 
  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id: "tile-layer",
    data: "https://api.maptiler.com/maps/toner-v2/256/{z}/{x}/{y}.png?key=WnDavn9jMjHyl7zWOqRp",
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        //type error: Property 'east' does not exist on type 'TileBoundingBox'.
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: undefined,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });
  return [tileLayer];
}
